(function (angular) {
	'use strict';

	var placeholderLinesObject = {
		bindings: {
			sectionCount: '<?',
			lineCount: '<?',
			placehold: '<',
			theme: '<?'
		},
		controller: [PlaceholderLinesFunction],
		controllerAs: 'placeholderLines',
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		transclude: true
	};

	angular
		.module('placeholderModule')
		.component('placeholderLines', placeholderLinesObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/placeholder/placeholder-lines.html';
	}

	function PlaceholderLinesFunction() {
		var placeholderLines = this;

		placeholderLines.$onInit = function() {
			placeholderLines.lineCount = placeholderLines.lineCount || 4;
			placeholderLines.sectionCount = placeholderLines.sectionCount || 1;
			placeholderLines.theme = placeholderLines.theme || 'light';
			placeholderLines.lineArr = [];
			placeholderLines.sectionArr = [];

			for(var i = 0; i < placeholderLines.lineCount; i++) {
				placeholderLines.lineArr.push(i);
			}

			for(var j = 0; j < placeholderLines.sectionCount; j++) {
				placeholderLines.sectionArr.push(j);
			}
		};
	}

})(window.angular);